import React from 'react';
import GameModeButton from '../components/GameModeButton';
import styles from './ModeSelection.module.css';

const ModeSelection = (props) => {
    return (
        <>
            <div className={styles.buffer}></div>
            <div className={styles.container}>
                <GameModeButton
                    kids={false}
                    chooseGameMode={props.chooseGameMode}
                    changeContainer={props.changeContainer} />
                <GameModeButton
                    kids={true}
                    chooseGameMode={props.chooseGameMode}
                    changeContainer={props.changeContainer} />
            </div>
        </>
    );
}

export default ModeSelection;